import { getCookie } from '../hookServices/cookiesManager';
import { haversineKm } from './ukraineRegions';

/** Round km for UI (same rules as Map embed). */
export function roundDistanceKm(km) {
  const n = Number(km);
  if (!Number.isFinite(n) || n < 0) {
    return null;
  }
  return n >= 100 ? Math.round(n) : Math.round(n * 10) / 10;
}

/** Distance to station in km from API meters or user GPS vs station coords. */
export function stationDistanceKmFromUser(station) {
  if (!station) {
    return null;
  }

  const meters = station.distanceMeters ?? station.distance_meters;
  if (meters != null && Number(meters) >= 0) {
    return roundDistanceKm(Number(meters) / 1000);
  }

  const lat = Number(station.latitude);
  const lon = Number(station.longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) {
    return null;
  }

  const cached = getCookie('userLocation');
  if (cached?.latitude == null || cached?.longitude == null) {
    return null;
  }

  const km = haversineKm(Number(cached.latitude), Number(cached.longitude), lat, lon);
  return roundDistanceKm(km);
}
